'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
var dates = require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
require('react-dates/initialize');
require('react-dates/lib/css/_datepicker.css');
var SelectWithLabel = require('../../inputs/SelectWithLabel/SelectWithLabel.js');
var styledComponents = require('./styled-components.js');
var DayElement = require('../components/DayElement/DayElement.js');
var utils = require('./utils.js');

var fmPrefix = 'componentLib.inputs.datePickerWithDropDownOptions';
var appWidePrefix = 'componentLib.appWide';
var DatePickerWithDropdownOptions = function (props) {
    var availableItems = props.availableItems, selectionType = props.selectionType, startDateProp = props.startDateProp, endDateProp = props.endDateProp, _a = props.reporter, reporter = _a === void 0 ? function () { return undefined; } : _a, title = props.title, startTitle = props.startTitle, endTitle = props.endTitle, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.hideDateInputs, hideDateInputs = _c === void 0 ? false : _c, StartProps = props.StartProps, EndProps = props.EndProps, disableStartEndDateField = props.disableStartEndDateField;
    var _d = reactIntl.useIntl(), fm = _d.formatMessage, locale = _d.locale;
    var dateFormat = dates.getFormat(locale);
    var getPastDays = function (amount) { return fm({ id: fmPrefix + ".pastDays" }, { amount: amount }); };
    var getNextDays = function (amount) { return fm({ id: fmPrefix + ".nextDays" }, { amount: amount }); };
    var Translations = {
        title: fm({ id: fmPrefix + ".title" }),
        startDateTitle: fm({ id: fmPrefix + ".startDateTitle" }),
        startAria: fm({ id: fmPrefix + ".startDateAriaLabel" }),
        endDateTitle: fm({ id: fmPrefix + ".endDateTitle" }),
        endAria: fm({ id: fmPrefix + ".endDateAriaLabel" }),
        placeholder: fm({ id: fmPrefix + ".placeholder" }),
        invalidDate: fm({ id: fmPrefix + ".invalidDate" }),
        minDate: fm({ id: fmPrefix + ".minDate" }),
        maxDate: fm({ id: fmPrefix + ".maxDate" }),
    };
    var TranslationItems = {
        '+7': getNextDays(7),
        '+14': getNextDays(14),
        '+30': getNextDays(30),
        '7': getPastDays(7),
        '14': getPastDays(14),
        '30': getPastDays(30),
        '60': getPastDays(60),
        custom: fm({ id: appWidePrefix + ".custom" }),
        thisWeek: fm({ id: appWidePrefix + ".thisWeek" }),
        thisMonth: fm({ id: appWidePrefix + ".thisMonth" }),
        thisYear: fm({ id: appWidePrefix + ".thisYear" }),
        nextWeek: fm({ id: appWidePrefix + ".nextWeek" }),
        nextMonth: fm({ id: appWidePrefix + ".nextMonth" }),
        lastWeek: fm({ id: appWidePrefix + ".lastWeek" }),
        lastMonth: fm({ id: appWidePrefix + ".lastMonth" }),
        lastYear: fm({ id: appWidePrefix + ".lastYear" }),
        allDates: fm({ id: appWidePrefix + ".allDates" }),
        today: fm({ id: appWidePrefix + ".today" }),
        reactivation: fm({ id: appWidePrefix + ".reactivation" }),
    };
    var defaultSelectionType = selectionType !== null && selectionType !== void 0 ? selectionType : availableItems[0];
    if (selectionType !== 'custom') {
        if (startDateProp || endDateProp) {
            defaultSelectionType = 'custom';
        }
        else {
            var selectedItems_1 = {};
            if (availableItems.length > 0) {
                availableItems.forEach(function (type) {
                    selectedItems_1[type] = true;
                });
            }
            if (!selectedItems_1[defaultSelectionType]) {
                defaultSelectionType = availableItems[0];
            }
        }
    }
    var _e = React.useState(true), firstLoad = _e[0], setFirstLoad = _e[1];
    var _f = React.useState(defaultSelectionType), selected = _f[0], setSelected = _f[1];
    var _g = React.useState(startDateProp), startDate = _g[0], setStartDate = _g[1];
    var _h = React.useState(endDateProp), endDate = _h[0], setEndDate = _h[1];
    var handleSelectChange = function (selectState) {
        var _a, _b;
        var dates = utils.getCustomDateRange(selectState, startDate, endDate);
        if (!dates) {
            return;
        }
        var start = dates.start, end = dates.end;
        setStartDate((_a = start === null || start === void 0 ? void 0 : start.startOf('day')) !== null && _a !== void 0 ? _a : null);
        setEndDate((_b = end === null || end === void 0 ? void 0 : end.endOf('day')) !== null && _b !== void 0 ? _b : null);
        setSelected(selectState);
    };
    React.useEffect(function () {
        if (firstLoad) {
            if (!startDate || !endDate) {
                handleSelectChange(selected);
            }
            setFirstLoad(false);
        }
    }, [firstLoad, selected, startDate, endDate]);
    React.useEffect(function () {
        if (firstLoad) {
            return;
        }
        // Reported start/end date need to be converted to a date/iso string
        // When in an invalid state values should not be repoted, may cause errors
        if (!utils.isDateValid(startDate) || !utils.isDateValid(endDate)) {
            return;
        }
        reporter({ startDate: startDate !== null && startDate !== void 0 ? startDate : null, endDate: endDate !== null && endDate !== void 0 ? endDate : null, selected: selected });
    }, [startDate, endDate, selected, firstLoad]);
    var onStartDateChange = function (date) {
        var _a;
        setSelected('custom');
        setStartDate((_a = date === null || date === void 0 ? void 0 : date.startOf('day')) !== null && _a !== void 0 ? _a : null);
    };
    var onEndDateChange = function (date) {
        var _a;
        setSelected('custom');
        setEndDate((_a = date === null || date === void 0 ? void 0 : date.endOf('day')) !== null && _a !== void 0 ? _a : null);
    };
    var showDateInputs = selected === 'custom' || (!hideDateInputs && selected !== 'allDates');
    var allAvailableItems = tslib.__spreadArrays(availableItems, ['custom']);
    var menuItems = allAvailableItems.map(function (item) {
        var display = TranslationItems[item.toString()];
        return {
            value: item,
            display: display,
        };
    });
    return (React__default.createElement(styledComponents.Main, { className: className },
        React__default.createElement(styledComponents.TitleContainer, null,
            React__default.createElement(SmallTitleText, { component: 'span' }, title !== null && title !== void 0 ? title : Translations.title,
                ":")),
        React__default.createElement(styledComponents.InputWrapper, null,
            React__default.createElement(SelectWithLabel, { reporter: handleSelectChange, menuItems: menuItems, defaultValue: defaultSelectionType, value: selected, style: { height: '35px' } })),
        showDateInputs && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(styledComponents.TitleContainer, null,
                React__default.createElement(SmallTitleText, { component: 'span' }, startTitle !== null && startTitle !== void 0 ? startTitle : Translations.startDateTitle,
                    ":")),
            React__default.createElement(styledComponents.InputWrapper, null,
                React__default.createElement(styledComponents.StyledDateInput, { disableToolbar: true, variant: 'inline', format: dateFormat, placeholder: Translations.placeholder, value: startDate, disableFuture: StartProps === null || StartProps === void 0 ? void 0 : StartProps.disableFuture, disablePast: StartProps === null || StartProps === void 0 ? void 0 : StartProps.disablePast, autoOk: true, maxDate: endDate !== null && endDate !== void 0 ? endDate : undefined, onChange: onStartDateChange, KeyboardButtonProps: {
                        'aria-label': Translations.startAria,
                    }, renderDay: DayElement, "data-testid": 'datepicker-start', invalidDateMessage: Translations.invalidDate, minDateMessage: Translations.minDate, maxDateMessage: Translations.maxDate, inputVariant: 'outlined', inputProps: {
                        'data-testid': 'datepicker-start-input',
                    }, disabled: selected !== 'custom' && disableStartEndDateField })),
            React__default.createElement(styledComponents.TitleContainer, null,
                React__default.createElement(SmallTitleText, { component: 'span' }, endTitle !== null && endTitle !== void 0 ? endTitle : Translations.endDateTitle,
                    ":")),
            React__default.createElement(styledComponents.InputWrapper, null,
                React__default.createElement(styledComponents.StyledDateInput, { disableToolbar: true, variant: 'inline', format: dateFormat, placeholder: Translations.placeholder, value: endDate, disableFuture: EndProps === null || EndProps === void 0 ? void 0 : EndProps.disableFuture, disablePast: EndProps === null || EndProps === void 0 ? void 0 : EndProps.disablePast, autoOk: true, minDate: startDate !== null && startDate !== void 0 ? startDate : undefined, onChange: onEndDateChange, KeyboardButtonProps: {
                        'aria-label': Translations.endAria,
                    }, renderDay: DayElement, "data-testid": 'datepicker-end', invalidDateMessage: Translations.invalidDate, minDateMessage: Translations.minDate, maxDateMessage: Translations.maxDate, inputVariant: 'outlined', inputProps: {
                        'data-testid': 'datepicker-end-input',
                    }, disabled: selected !== 'custom' && disableStartEndDateField }))))));
};

module.exports = DatePickerWithDropdownOptions;
